package app.bloomey.web.core.res

val Res.Destinations.adminPage: String
    get() = "/admin/"
val Res.Destinations.login: String
    get() = "/admin/login"

val Res.Destinations.users: String
    get() = "/admin/users"

val Res.Destinations.libraries: String
    get() = "/admin/libraries"
val Res.Destinations.videos: String
    get() = "/admin/videos"

val Res.Destinations.feedbacks: String
    get() = "/admin/feedbacks"